import { BadgePercent, Ban, Eye, SlidersHorizontal, FileText, ShieldCheck, Scale, Wallet } from "lucide-react";

const BENEFITS = [
  [BadgePercent, "Flat 10% commission", "One simple rate on rent + cleaning"],
  [Ban, "No FairStay guest fee", "Guests pay your price, cleaning and tax"],
  [Eye, "Transparent pricing", "Every line shown to guests and you"],
  [SlidersHorizontal, "You set the rates", "Nightly price and cleaning fee are yours"],
  [FileText, "Clear tax reporting", "Monthly filing summary per permit"],
  [ShieldCheck, "Screened owners", "Every listing is checked before it goes live"],
  [Scale, "Fair dispute review", "Both sides heard, a person decides"],
  [Wallet, "Transparent payouts", "See each booking's payout and fees"],
];

export function HostBenefits() {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid="host-benefits">
      {BENEFITS.map(([Icon, t, d], i) => (
        <div key={t} className="rounded-2xl border bg-white p-3" data-testid={`host-benefit-${i}`}>
          <Icon className="h-5 w-5 text-primary" />
          <p className="mt-2 text-sm font-semibold leading-tight">{t}</p>
          <p className="mt-0.5 text-xs text-stone-500">{d}</p>
        </div>
      ))}
    </div>
  );
}
